var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.canShareScreen),expression:"canShareScreen"}],attrs:{"id":"menu-share-screen"}},[_c('i',{staticClass:"icon icon-share"}),_c('span',{staticClass:"bjy-screen-share"})])
}
var staticRenderFns = []

export { render, staticRenderFns }